// 숫자 한글 체크 , 천단위 콤마
export const formatLocalString = value => {
    // null, undefined 또는 빈 문자열 체크
    if (value === null || value === undefined || value === '') {
        return '0';
    }
    
    // 입력값이 문자열이고, 숫자로만 구성되어 있다면 숫자로 변환
    if (typeof value === 'string' && !isNaN(value)) {
        value = Number(value);
    }

    // 입력값이 숫자인 경우, toLocaleString을 사용하여 현지화된 문자열로 변환
    if (typeof value === 'number' && !isNaN(value)) {
        return value.toLocaleString();
    }

    // 변환할 수 없는 값인 경우 기본값 반환 (에러를 던지지 않음)
    console.warn('Invalid value for formatLocalString:', value);
    return '0';
};

// 숫자만
export const numericRegex = value => {
    const regex = /[^0-9]/g;
    return value.replace(regex, '');
};

export const validateInput = (input, isChar = false) => {
    const regExp = /[{}[\]?.,;:|)*~`!^_+<>@#$%&=('""]/g;

    const hasSpecialCharacter = regExp.test(input);
    const hasNumber = /\d/.test(input);
    const hasLetter = /[A-Za-z]/.test(input);
    if (isChar) {
        // 특수문자, 숫자, 영문자 중 하나라도 없으면 false 반환
        if (!hasSpecialCharacter || !hasNumber || !hasLetter) {
            return false;
        }
    } else {
        if (hasSpecialCharacter || !hasNumber || !hasLetter) {
            return false;
        }
    }
    return true;
};



// 전화번호 포맷팅 (하이픈 추가)
export const formatPhoneNumber = (phoneNumber) => {
    // null, undefined, 빈 배열, 빈 문자열 체크
    if (!phoneNumber || (Array.isArray(phoneNumber) && phoneNumber.length === 0) || phoneNumber === '') {
        return '';
    }
    
    // 문자열이 아닌 경우 문자열로 변환
    const phoneStr = String(phoneNumber);
    
    // 숫자만 추출
    const numbers = phoneStr.replace(/[^0-9]/g, '');
    
    // 숫자가 없는 경우 빈 문자열 반환
    if (numbers.length === 0) return '';
    
    // 입력 중에도 하이픈 추가
    if (numbers.length <= 3) {
        return numbers;
    } else if (numbers.length <= 7) {
        return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
    } else {
        return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7)}`;
    }
};

export const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
};

